if (typeof window.gettext === "undefined") {
  window.gettext = function(str) { return str; };
}

if (typeof window.ngettext === "undefined") {
  window.ngettext = function(singular, plural, n) {
	  return n > 1 ? plural : singular;
  };
}

if (typeof window.pgettext === "undefined") {
  window.pgettext = function(context, str) { return str; };
}

if (typeof window.npgettext === "undefined") {
  window.npgettext = function(context, singular, plural, n) {
	return n > 1 ? plural : singular;
  };
}

if (typeof window.interpolate === "undefined") {
  window.interpolate = function(fmt, obj, named) {
  // Support both positional (%s) and named (%(name)s) interpolation
  if (named) {
    // Named placeholders: %(key)s
    return fmt.replace(/%\(([^)]+)\)s/g, function(match, key) {
    var value = obj && Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : "";
    return String(value);
    });
  } else {
    // Positional placeholders: %s
    var arr = Array.isArray(obj) ? obj.slice() : [obj];
    var idx = 0;
    return fmt.replace(/%s/g, function() {
    var value = idx < arr.length ? arr[idx++] : "";
    return String(value);
    });
  }
  };
}
